export const LEV1 = [
  "InitialLoanAmount",
  "OrgInterestRate",
  "TotalRehabBudget",
  "financedBudget",
  "TotalOrgAndDiscountPoints",
];


  export const quickLoanSizingLEV1 = ["InterestOnlyFlag", "ioPeriod", "PrePaymentPenaltyTypeMonths", ""];

  export const detailedLoanSizingLEV1 = ["BorrowerRequested", "PrePaymentPenaltyTypeMonths", "PrePaymentPenaltyType", "InterestOnlyFlag", "ioPeriod",
    "rateType",
    "armType",
    "armIndex",
    "grossArmMargin",
    "initialRateAdjustmentDate",
    "initialPayAdjustmentDate",
    "initialPeriodicCap",
    "subsequentPeriodicCap",
    "lifeTimeCap",
    "lifeTimeFloor",
    "originationFee",
    "CreditCommitteeInterestRate",
    "FinalToorakPrice"
  ];

